export default "__VITE_ASSET__c9a0ea55__"